import { TinyMCEShowcase } from 'components'

export const TextboxDrawer = () => <TinyMCEShowcase />

export default TextboxDrawer
